import {Grid2} from "@mui/material"
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined"
import {Card, RefineListView } from "@/components"

export const DashboardPage: React.FC = () => {
  return (
    <RefineListView>
      <Grid2 container columns={24} spacing={3}>
        <Grid2
          size={{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 10,
          }}
          sx={{
            height: "264px",
          }}
        >
          <Card
            title="dashboard"
            icon={<MonetizationOnOutlinedIcon />}
            sx={{
              ".MuiCardContent-root:last-child": {
                paddingBottom: "24px",
              },
            }}
            cardContentProps={{
              sx: {
                height: "208px",
              },
            }}
          >
          </Card>
        </Grid2>
        <Grid2
          size={{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 7,
          }}
          sx={{
            height: "264px",
          }}
        >
          <Card
            title="daily Orders"
            icon={<MonetizationOnOutlinedIcon />}
            sx={{
              ".MuiCardContent-root:last-child": {
                paddingBottom: "24px",
              },
            }}
            cardContentProps={{
              sx: {
                height: "208px",
              },
            }}
          >
          </Card>
        </Grid2>
        <Grid2
          size={{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 12,
            xl: 7,
          }}
          sx={{
            height: "264px",
          }}
        >
          <Card
            title="new Customers"
            icon={<MonetizationOnOutlinedIcon />}
            sx={{
              ".MuiCardContent-root:last-child": {
                paddingBottom: "24px",
              },
            }}
            cardContentProps={{
              sx: {
                height: "208px",
              },
            }}
          >
          </Card>
        </Grid2>
      </Grid2>
    </RefineListView>
  )
}